import { ClientesService } from './../../services/clientes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild("mensajeRecuperar") mensajeRecuperar: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  @ViewChild("botonCerrar") botonCerrar: ElementRef;
  @ViewChild("mensajeRecuperar2") mensajeRecuperar2: ElementRef;
  @ViewChild("formulario2") formulario2: ElementRef;
  @ViewChild("botonCerrar2") botonCerrar2: ElementRef;
  @ViewChild("mensajeJuridico") mensajeJuridico:ElementRef;
  @ViewChild("mensajeLaboral") mensajeLaboral:ElementRef;
  email:string;
  password:string;
  email2:string;
  password2:string;
  primerIntento:boolean=true;
  tipo:string;
  cliente={};
  cliente2={};

  constructor(private auth:AuthService, private router:Router, private activatedRoute:ActivatedRoute,
              private renderer:Renderer2) {
    
    this.cliente={CLcif:""};
    
    if(this.auth.isAuthenticated()){
      
      this.router.navigate(['home']);
    }
  }
   

  ngOnInit() {
    
  }

  loginJuridico(){
    
    this.auth.loginCliente(this.email,this.password).subscribe(resp=>{
      
      if(resp["err"]==false){
        this.router.navigate(["/home"]);
      }else{
        let texto=this.renderer.createText(resp["msg"]);
        this.renderer.appendChild(this.mensajeJuridico.nativeElement, texto);
        this.email="";
        this.password="";
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeJuridico.nativeElement, texto);
        }, 1500);
      }
    });
    
  }

  loginLaboral(){
    this.auth.loginClientePyme(this.email2,this.password2).subscribe(resp=>{
      
      if(resp["err"]==false){
        this.router.navigate(["/home"]);
      }else{
        let texto=this.renderer.createText(resp["msg"]);
        this.renderer.appendChild(this.mensajeLaboral.nativeElement, texto);
        this.email2="";
        this.password2="";
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeLaboral.nativeElement, texto);
        }, 1500);
      }
    });
  }

  guardarNuevaPass(myform: NgForm){
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
    if(myform.valid){
      
      this.auth.recuperarPassCliente(this.cliente)
      .subscribe(resp=>{
        let texto=this.renderer.createText("");
                
        if(resp["err"]==false){
          texto=this.renderer.createText("Se le ha enviado su nueva contraseña al correo.");
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement,"color", "green");
        }else{
          texto=this.renderer.createText(resp["msg"]);
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement, "color", "red");
        }
        this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
          this.botonCerrar.nativeElement.click();
        }, 1500);

      });
      
    }
  }


  guardarNuevaPassPymes(myform: NgForm){
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");
    
    if(myform.valid){
      
      this.auth.recuperarPassClientePymes(this.cliente2)
      .subscribe(resp=>{
        let texto=this.renderer.createText("");
                
        if(resp["err"]==false){
          texto=this.renderer.createText("Se le ha enviado su nueva contraseña al correo.");
          this.renderer.setStyle(this.mensajeRecuperar2.nativeElement,"color", "green");
        }else{
          texto=this.renderer.createText(resp["msg"]);
          this.renderer.setStyle(this.mensajeRecuperar2.nativeElement, "color", "red");
        }
        this.renderer.appendChild(this.mensajeRecuperar2.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar2.nativeElement, texto);
          this.botonCerrar2.nativeElement.click();
        }, 1500);

      });
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts